import { z } from 'zod'

import axios from '../../function/axiosInstance'
import extract from '../../function/extract'

const ResponseSchema = z.object({
  users: z.number(),
  assignments: z.number()
})

const AverageSubmissionSchema = z.object({
  response: ResponseSchema
})

export type AverageSubmission = z.infer<typeof AverageSubmissionSchema>

const getAvgSubmissionByRole = async (role: string): Promise<ApiResponseV2<AverageSubmission>> => {
  try {
    z.string().parse(role)

    const endpoint = `/users/avg-submission/${role}`
    const response = await axios.get<AverageSubmission>(endpoint)

    AverageSubmissionSchema.parse(response.data)

    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

export default getAvgSubmissionByRole
